import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetLuckyWheelResponse } from '@/modules/promotion/type'
import LuckyWheelTable from '../LuckyWheelTable'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import LuckyWheelDisplay from '../LuckyWheelDisplay'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useMutationUpdateLuckyWheel from '@/modules/promotion/api/hooks/useMutateUpdateLuckyWheel'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useState } from 'react'
import ResetQuotaDialog from './components/ResetQuotaDialog'

interface LuckyWheelListingProps {
	data: GetLuckyWheelResponse[]
	isLoading?: boolean
}

export default function LuckyWheelListing({
	data,
	isLoading,
}: LuckyWheelListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_LUCKY_WHEEL,
	)
	const [isResetDialogOpen, setIsResetDialogOpen] = useState(false)

	const { mutate: updateLuckyWheel } = useMutationUpdateLuckyWheel({
		onSuccess: () => {
			toast.success('อัพเดทสำเร็จ')
			setIsResetDialogOpen(false)
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleResetQuota = () => {
		updateLuckyWheel({
			payload: {
				clearQuota: true,
			},
		})
	}

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`ตั้งค่ากงล้อ`}
					description="โควตากงล้อจะคิดเมื่อลูกค้าเล่นแบบไม่ฝากโปร"
				/>
				<div className="flex gap-2">
					{hasWritePermission && (
						<div>
							<div className="flex gap-2">
								<Button
									variant="destructive"
									onClick={() => setIsResetDialogOpen(true)}
								>
									รีเซ็ตโควต้า
								</Button>
								<Button asChild variant="default">
									<Link to="/operator/lucky-wheel/update">ตั้งค่ากงล้อ</Link>
								</Button>
							</div>
						</div>
					)}
				</div>
			</div>
			<Separator />
			{data.length > 0 ? (
				data.map((wheel) => (
					<div key={wheel.id} className="space-y-6">
						<LuckyWheelDisplay wheelData={wheel} disabled={!wheel.isActive} />
						<LuckyWheelTable data={data} isLoading={isLoading} />
					</div>
				))
			) : (
				<div className="flex flex-col items-center gap-4 py-8">
					<p className="text-lg text-muted-foreground">ไม่พบข้อมูลกงล้อ</p>
					{hasWritePermission && (
						<Button asChild variant="default">
							<Link to="/operator/lucky-wheel/update">ตั้งค่ากงล้อ</Link>
						</Button>
					)}
				</div>
			)}
			<ResetQuotaDialog
				isOpen={isResetDialogOpen}
				onClose={() => setIsResetDialogOpen(false)}
				onConfirm={handleResetQuota}
			/>
		</div>
	)
}
